import { useEffect, useState } from 'react';
import { BUILD_ESNAF } from '../../data/esnaf.generated';

/** Sitede yayinlanan isletme bilgisi — yalniz ad, logo, mahalle/ilce (telefon/adres YOK) */
export interface EsnafItem {
  name: string;
  slug: string;
  logo: string | null;
  mahalle: string | null;
  ilce: string | null;
}

/**
 * Derlemedeki liste ile hemen cizilir (prerender/Google bunu gorur), sayfa acilinca
 * /api/esnaf'tan canli liste gelirse onunla degistirilir (yeni esnaf en gec 1 saatte gorunur).
 */
export function useEsnaf(): EsnafItem[] {
  const [items, setItems] = useState<EsnafItem[]>(BUILD_ESNAF);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/esnaf')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!cancelled && d && Array.isArray(d.items) && d.items.length > 0) setItems(d.items);
      })
      .catch(() => { /* derlemedeki liste kalir */ });
    return () => { cancelled = true; };
  }, []);

  return items;
}

export function areaLabel(item: EsnafItem): string {
  return [item.mahalle, item.ilce].filter(Boolean).join(', ');
}

/** Ilceye gore grupla: en kalabalik ilce once, ilcesi bilinmeyenler en sonda */
export function groupByIlce(items: EsnafItem[]): { ilce: string; items: EsnafItem[] }[] {
  const map = new Map<string, EsnafItem[]>();
  for (const item of items) {
    const key = item.ilce || 'Diğer';
    map.set(key, [...(map.get(key) || []), item]);
  }
  return [...map.entries()]
    .map(([ilce, list]) => ({ ilce, items: list }))
    .sort((a, b) => (a.ilce === 'Diğer' ? 1 : 0) - (b.ilce === 'Diğer' ? 1 : 0) || b.items.length - a.items.length);
}
